module.exports = __webpack_public_path__ + "assets/img/activity-time-f15b1358.png";